/**
 * Created by andrey on 08.08.2025
 */

cc.ScaleTo = function (duration, sx, sy) {
    cc.ActionInterval.call(this, duration);

    this._scaleX = 1;
    this._scaleY = 1;
    this._startScaleX = 1;
    this._startScaleY = 1;
    this._endScaleX = 0;
    this._endScaleY = 0;
    this._deltaX = 0;
    this._deltaY = 0;

    sx !== undefined && this.initWithDuration(duration, sx, sy);
};

cc.ScaleTo.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.ScaleTo,

    initWithDuration: function (duration, sx, sy) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            this._endScaleX = sx;
            this._endScaleY = (sy != null) ? sy : sx;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._startScaleX = target.scaleX;
        this._startScaleY = target.scaleY;
        this._deltaX = this._endScaleX - this._startScaleX;
        this._deltaY = this._endScaleY - this._startScaleY;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        if (this.target) {
            this.target.scaleX = this._startScaleX + this._deltaX * dt;
            this.target.scaleY = this._startScaleY + this._deltaY * dt;
        }
    }
});

cc.scaleTo = (duration, sx, sy) => new cc.ScaleTo(duration, sx, sy);
